"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClassNames = addClassNames;
exports.classNamePropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
/*
utils for dealing with cssClasses
*/

/*
proptype definitions for CSS classes
*/
var classNamePropTypes = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf([_propTypes["default"].string])]);

/*
given array of original css class arrays
and new css classes
return new array with combined CSS classes, or the original aray
*/
exports.classNamePropTypes = classNamePropTypes;
function addClassNames(newClasses, allClasses) {
  if (newClasses && typeof newClasses === 'string') return allClasses.concat([newClasses]);
  if (newClasses && Array.isArray(newClasses)) return allClasses.concat(newClasses);
  return allClasses;
}